<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="tableCardDiv">
    <vx-card class="overflow-hidden" >
      <div slot="no-body">
        <div class="vx-card__header">
          <div class="vx-card__title">
            <h4>{{ $t(i18n) || title }}</h4>
          </div>
          <div class="vx-card__actions">
            <div class="vx-card__action-buttons">
              <feather-icon v-if="enableZoomIn" @click="zoomIn" icon="SearchIcon" svgClasses="h-6 w-6" class="ml-4" />
              <feather-icon v-if="enableDrilling" @click="drillTo" icon="CornerRightDownIcon" svgClasses="h-6 w-6" class="ml-4"/>
            </div>
          </div>
        </div>
        <div>
          <ag-grid-vue
            ref="agGridTable"
            :context="context"
            class="ag-theme-material w-200 my-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="tableData"
            rowSelection="none"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="false"
            :suppressPaginationPanel="true"
            :enableCellChangeFlash="false">
          </ag-grid-vue>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

export default {
  props: {
    title: {
      type: String
    },
    i18n : {
      type: String
    },
    linkTo: {
      type: String
    },
    enableZoomIn: {
      type: Boolean,
      default: false
    },
    size : {
      type: Number,
      default : 0
    },
    labels : {

    },
    tableData: {
      // type: Array,
      // required: true
    },
    columnDefs: {

    }
  },
  
  computed : {
    enableDrilling() {
      return this.linkTo !== "" && typeof this.linkTo !== 'undefined';
    }
  },
  data () {
    return {
      chartOptions: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false
      },
      gridApi: null,
      context: { componentParent: this }
      
    }
  },
  components: {
    AgGridVue
  },
  methods: {
    zoomIn() {
      this.$emit("onZoomIn");
    },
    drillTo() {
      this.$emit("onDrillTo", this.linkTo);
    }
  }
}
</script>
<style lang="scss">
#tableCardDiv {
  .ag-grid-table {
    height: 335px;
  }
}
</style>